<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="150">
        </div>

        <div class="enter-membership-form">
            <div class="member-log-in-title">
                    アカウントにサインイン
                </div>

                <div class="sign-up-for-membership-page">
                    初めてELEVATEメンバーシップをご利用される方の<a href="sign-up" class="sign-up-for-membership-page">新規会員登録はこちら</a>
                </div>

                <div class="membership-input">
                    <div class="membership-number-text-field-label">
                    メールアドレス
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="email">
                </div>

                <div class="membership-number-text-field-label">
                    パスワード
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="password" type="password">
                </div>

                <div class="membership-number-text-field-sub-label">
                     <a href="reset-password" class="membership-number-text-field-sub-label"> パスワードをお忘れですか？</a>
                </div>
            </div>

            <div class="button-container">
                <button type="button" @click="login()" id="login-submit" class="membership-number-submit">続ける</button>
            </div>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 120pt;
        object-fit: contain;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
    }
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 25pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 40pt;
    text-align: left;
    display: flex;
}

</style>


<script setup>
    //import { store } from '../store.js'
    import { db }  from '../main.js'
    import { useRouter } from "vue-router";
    import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
    import { doc, getDoc } from "firebase/firestore"; 
    import { useUserStore } from "@/piniastore";
    import NProgress from 'nprogress';
    import 'nprogress/nprogress.css';
    const router = useRouter();
    
    function login() { 
        const email = document.getElementById("email").value;
        const password = document.getElementById("password").value;

        NProgress.start();
        const auth = getAuth();

        const store = useUserStore();

        document.getElementById("login-submit").disabled = true ;
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {

            getDoc(doc(db, "users", userCredential.user.uid))
                .then((result) => {
                    store.updateUser(userCredential.user);

                    const referralCode = result.data()['referral_code'];
                    store.updateReferralCode(referralCode);

                    if (store.cameFromEventPage) {
                        router.push('/pre-purchase')
                    } else {
                        router.push('/event-schedule');
                    }
                
                    document.getElementById("login-submit").disabled = false ;
                    NProgress.done();
                })
                .catch((error) => {
                    document.getElementById("login-submit").disabled = false ;
                    NProgress.done()
                    alert(error.message)
                })
        })
        .catch((error) => {
            alert(error.message)
            document.getElementById("login-submit").disabled = false ;
            NProgress.done();
    });

        
     } 
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>